import { z } from "zod";
import { FacebookCarouselEntity } from "./facebook-carousel.entity";
import { FacebookPostEntity } from "./facebook-post.entity";
import { FacebookStoryEntity } from "./facebook-story.entity";
import { GooglePerformanceMaxEntity } from "./google-performance-max.entity";
import { InstagramCarouselEntity } from "./instagram-carousel.entity";
import { InstagramSingleImageEntity } from "./instagram-single-image.entity";
import { InstagramStoryEntity } from "./instagram-story.entity";

export enum PublicationTemplateType {
  FacebookCarousel = "FACEBOOK_CAROUSEL",
  FacebookPost = "FACEBOOK_POST",
  FacebookStory = "FACEBOOK_STORY",
  GooglePerformanceMax = "GOOGLE_PERFORMANCE_MAX_AD",
  InstagramCarousel = "INSTAGRAM_CAROUSEL",
  InstagramSingleImage = "INSTAGRAM_SINGLE_IMAGE",
  InstagramStory = "INSTAGRAM_STORY",
}

export const RecommendedScheduleParser = z
  .object({
    id: z.string(),
    publication_template_id: z.string(),
    start: z.number(),
    end: z.number().nullable(),
  })
  .strict();

export type RecommendedScheduleEntity = Readonly<
  z.infer<typeof RecommendedScheduleParser>
>;

export interface SchedulePeriodEntity {
  readonly start: string;
  readonly end?: string;
}

export interface IPublicationTemplateEntity {
  readonly id: string;
  readonly publicationTemplateType: PublicationTemplateType;
  readonly recommendedSchedules?: RecommendedScheduleEntity[];
}

export type PublicationTemplateEntity =
  | InstagramCarouselEntity
  | InstagramStoryEntity
  | InstagramSingleImageEntity
  | FacebookCarouselEntity
  | FacebookPostEntity
  | FacebookStoryEntity
  | GooglePerformanceMaxEntity;
